///system/reportissue Send feedback
export const SEND_FEEDBACK = "SEND_FEEDBACK";
export const SEND_FEEDBACK_SUCCESS = "SEND_FEEDBACK_SUCCESS";
export const SEND_FEEDBACK_ERROR = "SEND_FEEDBACK_ERROR";
